$(document).ready(function () {
    const page = {};
    page.menu = $('#model-menu');

    if (!page.menu.length) return;

    page.menuOffset = page.menu.offset().top;
    page.header = $('.header');
    page.activeClass = 'model-menu_fixed';

    $(document).on('scroll', function () {
        page.headerHeight = page.header.innerHeight();
        const scrollTop = $(this).scrollTop();
        if (scrollTop + page.headerHeight >= page.menuOffset) {
            if (!page.menu.hasClass(page.activeClass))
                page.menu.addClass(page.activeClass);
        } else {
            page.menu.removeClass(page.activeClass);
        }

    });

    $(window).on('resize orientationchange', () => {
        clearTimeout(page.timeout);
        page.timeout = setTimeout(function () {
            page.menuOffset = page.menu.offset().top;
        }, 100);
    });

});